export default __webpack_public_path__ + "static/media/1757.43cd5dbd.png";